import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; // Import the CSS for custom styling

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();

        // Hardcoded admin credentials
        const adminEmail = 'admin@biznet.com';
        const adminPassword = 'admin123';

        if (email === adminEmail && password === adminPassword) {
            // If credentials match, redirect to admin dashboard
            navigate('/admin');
        } else {
            // Display error if credentials are incorrect
            setError('Invalid email or password');
        }
    };

    return (
        <div className="login-page">
            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <div className="login-box">
                            <h2 className="text-center">Admin Login</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleLogin}>
                                <Form.Group controlId="formBasicEmail" className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword" className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Group>

                                <Button className="btn-gradient px-3" type="submit" block>
                                    Login
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default LoginPage;
